<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-等级管理-编辑等级
  -->
  <el-dialog title="申请类目资质" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="600px">
    <el-form size="small" :model="form" ref="form">
      <div class="table-wrap">
        <el-row>
          <el-col :span="25">
            <div class="pb16">
              <span class="gray9">类目：</span>
              {{form.first_cat_name}} - {{form.second_cat_name}} - {{form.third_cat_name}}
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="25">
            <div class="pb16">
              <span class="gray9">温馨提示：</span>
              <div class="red">{{form.qualification}}</div>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="form.status==9">
          <el-col :span="25">
            <div class="pb16">
              <span class="gray9">审核备注：</span>
              <div class="red">{{form.reject_reason}}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-form-item label="营业执照或组织机构代码证图片" :label-width="formLabelWidth" :rules="[{required: true,message: '请输入营业执照或组织机构代码证图片'}]">
        <el-button @click="openUpload('license')">选择图片</el-button>
        <img class="mt10" v-img-url="form.license" width="200">
      </el-form-item>
      <el-form-item label="资质材料图片：" :label-width="formLabelWidth" :rules="[{ required: true, message: '请上传资质材料图片' }]" prop="certificate">
        <div class="draggable-list">
         <div class="item img-select" @click="openUpload('certificate')"><i class="el-icon-plus"></i>添加</div>
          <draggable class="wrapper" v-model="form.certificate">
            <transition-group>
              <div class="item" v-for="(item, index) in form.certificate" :key="item">
                <img v-img-url="item" style="width:100px;height:100px;" />
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
         
        </div>
      </el-form-item>

    </el-form>

    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button v-if="form.status==-1 || form.status==9" type="primary" @click="shopcatApply" :disabled="submit_loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import MinistoreApi from '@/api/ministore.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      Upload: Upload
    },
    data() {
      return {
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,
        isupload: false,
        type: ''
      };
    },
    props: ['open_apply', 'form'],
    created() {
      console.log(this.open_apply)
      this.form.license = this.form.license?this.form.license:'';
      this.form.certificate = this.form.certificate?this.form.certificate:[];
      this.dialogVisible = this.open_apply;
    },
    methods: {
      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },

      /*删除商品图片*/
      deleteImg(index) {
        this.form.certificate.splice(index, 1);
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null) {
          if (this.type == 'license') {
            this.form.license = e[0].file_path;
          }
          if (this.type == 'certificate') {
            let imgs = this.form.certificate;
            e.forEach(item=>{
              imgs = imgs.concat(item.file_path);
            });
            this.$set(this.form, 'certificate', imgs);
          }
        }
        this.isupload = false;
      },
      /*提交审核*/
      shopcatApply() {
        let self = this;
        let params = self.form;
        console.log(params)
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;
            MinistoreApi.shopcatApply(params, true)
              .then(data => {
                self.submit_loading = false;
                self.$message({
                  message: '恭喜你，提交成功，请等待审核',
                  type: 'success'
                });
                self.dialogFormVisible(true);

              })
              .catch(error => {
                self.submit_loading = false;
              });

          }
        });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/ministore/shopcat/apply.vue